import {Component, Input} from '@angular/core';
import {OpenAPIService} from '../services/openapi';
import {UtilsService} from '../services/utils';
import {TrackerService} from '../services/tracker';

declare let window:any;

const PRISM_LANGUAGES = {
  'node': 'javascript',
  'curl': 'bash',
}

const LANGUAGE_LABELS = {
  'node': 'NodeJS',
  'javascript': 'JavaScript',
  'php': 'PHP',
  'ruby': 'Ruby',
  'html': 'HTML',
  'java': 'Java',
  'python': 'Python',
  'csharp': 'C#',
  'curl': 'cURL',
}

const CodeTemplate = require('../../../tmp/plugins/code-template.js');

const LANGUAGES = window.config.codegen.languages.map(lang => {
  if (typeof lang === 'string') lang = {id: lang};
  lang.label = lang.label || LANGUAGE_LABELS[lang.id] || lang.id;
  lang.highlight = lang.highlight || PRISM_LANGUAGES[lang.id] || lang.id;
  return lang;
})

const shiftLines = (code, numSpaces) => {
  if (!numSpaces) return code;
  var lines = code.split('\n');
  var spaces = Array(numSpaces + 1).join(' ');
  return lines.map(function(l, idx) {return (l && idx > 0) ? spaces + l : l}).join('\n');
}

@Component({
    selector: 'sample-code',
    templateUrl: '../views/sample-code.pug',
})
export class SampleCodeComponent {
  @Input('code') codeSnippets;
  @Input() answers;
  @Input() apiCall;
  @Input() templateInput;
  @Input() editing;
  @Input() disableCodegen;
  sampleCode:string;
  sampleCodeHTML:string;
  showSetupCode:boolean;
  showSetupCheckbox:boolean;
  languages:any[] = LANGUAGES;
  currentLanguage:any = LANGUAGES[0];

  constructor(private openapi:OpenAPIService,
              private utils:UtilsService,
              private tracker:TrackerService) {}

  ngOnChanges() {
    if (this.editing) {
      this.languages = LANGUAGES;
    } else if (this.codeSnippets) {
      this.languages = LANGUAGES.filter(l => this.codeSnippets[l.id]);
    } else {
      this.languages = LANGUAGES.filter(l => l.id !== 'html');
    }
    if (this.languages.indexOf(this.currentLanguage) === -1) {
      this.currentLanguage = this.languages[0];
    }
    if (window.localStorage) {
      let lang = window.localStorage.getItem('language');
      if (lang) this.currentLanguage = this.languages.filter(l => l.id === lang)[0] || this.currentLanguage;
    }
    this.refreshSampleCode();
  }

  ngAfterViewInit() {
    new window.Clipboard('.copy-button');
  }

  changeLanguage(lang) {
    this.currentLanguage = lang;
    if (window.localStorage) {
      window.localStorage.setItem('language', this.currentLanguage.id);
    }
    this.tracker.track('set_language', {language: this.currentLanguage.id});
    this.refreshSampleCode();
  }

  refreshSampleCode() {
    if (!this.apiCall && !(this.codeSnippets && Object.keys(this.codeSnippets).length)) return;
    let template = this.codeSnippets ? this.codeSnippets[this.currentLanguage.id] : null;
    let setupTemplate = null;
    this.showSetupCheckbox = false;
    if (!template || template === 'auto') {
      template = window.config.codegen.templates[this.currentLanguage.id];
      if (window.config.codegen.setupTemplates && (!this.apiCall || !this.apiCall.disableSetupCode)) {
        this.showSetupCheckbox = true;
        setupTemplate = window.config.codegen.setupTemplates[this.currentLanguage.id];
      }
    }
    if (!template) return;
    let tmpl = new CodeTemplate({
      swagger: this.openapi.parsed,
      template: template,
      setupTemplate: setupTemplate,
      language: this.currentLanguage.id,
    });
    if (this.apiCall) {
      this.templateInput.path = this.apiCall.path;
      this.templateInput.method = this.apiCall.method;
    }
    this.templateInput.answers = this.openapi.getAnswers(this.answers);
    this.templateInput.showSetup = this.showSetupCode;
    this.templateInput = this.utils.getTemplateInput(this.templateInput);
    this.sampleCode = '';
    try {
      this.sampleCode = tmpl.render(this.templateInput);
    } catch (e) {
      this.sampleCode = e.message;
      console.log(e);
    }
    let grammar = window.Prism.languages[this.currentLanguage.highlight];
    this.sampleCodeHTML = grammar ? window.Prism.highlight(this.sampleCode || '', grammar) : this.sampleCode;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/sample-code.ts